import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

import widgetReducer from './widget'
import messageReducer from './messages'
import settingsReducer from './settings'
import captchaReducer from './captcha'
import appVersionReducer from './app-version'
import { logger } from 'redux-logger'
import { compact } from 'lodash'

const persistConfig = {
  key: 'runelab-bot',
  storage,
  blacklist: [],
}

const reducers = combineReducers({
  widgetState: widgetReducer,
  messageState: messageReducer,
  settingsState: settingsReducer,
  captchaState: captchaReducer,
  appVersionState: appVersionReducer,
})
const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: compact([logger]),
})
export const persistor = persistStore(store)
